/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/style-prop-object */
import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes, { any } from 'prop-types';

import AvatarV3 from './AvatarV3';
import CollegeCoachAddProspect from './CollegeCoachAddProspect';
import CollegeProspectBadgeToggle from './CollegeProspectBadgeToggle';
import RatingDisplayV5 from '../RatingDisplayV5';
import ShareUrlPopUp from '../../InfoPopUps/ShareUrlPopUp';
import JoinMeOnTourPopUp from '../../PopUps/JoinMeOnTourPopup';
import UnClaimedProfileMessagePopup from '../../PopUps/UnClaimedProfileMessagePopup';
import Icon from '../../Img/Icon';
import PlayerBookmark from '../../SavedLists/PlayerBookmark';
import TrackedClick from '../../Analytics/TrackedClick';
import withAuth from '../../hocs/withAuth';
import { getClickAttrs } from '../../Analytics/gtag';
import { useStatsig } from '../../hooks/useStatsig';
import { useCPPDynamicConfig } from '../../hooks/useCPPDynamicConfig';
import { getRatingDetails, setRatingChoice } from '../../../utils';
import { collegeProspectMaxAge, collegeProspectMinAge } from '../../../utils/constants';

import config from '../../../../config';

import styles from './headerV3.scss';

const ProfileHeader = (props) => {
    const { playerId, isEligibleForPaidHit, isSendingPaidHitRequest, onRequestPaidHitClicked, onViewPaidHitsClicked, isPlayerSavedToList, isPlayerSaved, isSavedStatusLoading, savedPlayerListIds, onSaveToListSuccess, 'data-testid': dataTestId } = props;
    const tid = (suffix) => (dataTestId ? `${dataTestId}.${suffix}` : undefined);
    const {
        profileImage,
        playerProfileImages,
        firstName,
        lastName,
        displayName,
        homeClub,
        location,
        descriptionId,
        playerCollegeDetails,
        descriptionLong,
        gender,
        residence,
    } = props.profileData;

    const { claimedPlayer, isPowered } = props?.auth?.user || {};

    const userLoggedIn = props?.auth?.user;
    const isOwnProfile = userLoggedIn && ((props.profileData && claimedPlayer) ? (props.profileData.id === claimedPlayer.playerId) : false);
    const isProProfile = props?.profileData?.isPro;
    const isProfileClaimed = props?.profileData?.claimed;
    const isPaidHitter = props?.profileData?.isPaidHitter;

    const { isCollegeProspectPowerEnabled } = useCPPDynamicConfig();
    const [badgeOverride, setBadgeOverride] = useState(null);
    const isBadgeOwnerOverAgeCap = !!props.profileData?.age && props.profileData.age > collegeProspectMaxAge;
    const isBadgeOwnerUnderAgeMin = !!props.profileData?.age && props.profileData.age < collegeProspectMinAge;
    const isBadgeOwnerProgressionBall = getRatingDetails(setRatingChoice({ player: props.profileData || {} }), isPowered, true, false, false).showPBRRating;
    // Own profile trusts the viewer's auth entitlement: the profile payload's isPowered can lag
    // (club-assigned Power is not reflected there), which would pin the badge toggle off.
    const isBadgeOwnerPowered = isOwnProfile ? !!isPowered : !!props.profileData?.isPowered;
    const isBadgeOwnerEligible = isCollegeProspectPowerEnabled &&
        !isBadgeOwnerOverAgeCap &&
        !isBadgeOwnerUnderAgeMin &&
        isBadgeOwnerPowered &&
        !isBadgeOwnerProgressionBall;
    const showCollegeProspectBadge = isBadgeOwnerEligible && (badgeOverride ?? !!props.profileData?.displayCollegeProspectBadge);
    const isCppEligibleCoach = !!userLoggedIn?.isCollegeCoachCppEligible;

    const showCollegeLink = descriptionId !== 0 && !!playerCollegeDetails;
    const locationText = descriptionLong || residence;
    const showLocationDivider = !!homeClub && !!(location?.display || descriptionLong);

    const {
        handleUploadPhoto,
        handleUploadPhotoPhotoStart,
        handleRemoveProfilePhoto,
        menuSelected,
    } = props;

    const { checkGate, featureGates } = useStatsig();
    const savedListEnabled = checkGate(featureGates.SAVED_PLAYER_LIST_ROLLOUT);

    const handleOnLinkCopied = () => {
        if (window?.analytics) {
            const path = '/share/player';
            const properties = {
                path,
                url: path,
                title: props.profileData.displayName,
            };

            window.analytics.page('share player profile', 'share link', properties);
        }
    };

    const handleOnRequestPaidHitClicked = () => {
        onRequestPaidHitClicked();
    };

    const handleOnViewPaidHitsClicked = () => {
        onViewPaidHitsClicked();
    };

    const onTennisGetRatedClick = () => {
        props.history.push(`/onboarding-survey?return=/profiles/${props.profileData.id}`);
    };

    const onPickleballGetRatedClick = () => {
        props.history.push(`/pickleball-survey?return=/profiles/${props.profileData.id}`);
    };

    const handleProfileMerge = () => {
        menuSelected({
            label: 'Request Profile Merge',
            value: 'RPM',
            redirectPath: `https://support.${config.siteBaseUrl}/support/tickets/new`,
            redirectSearch: ``,
        });
    };

    const handleSaveToList = () => {
        menuSelected({
            label: 'Save to List',
            value: 'STL',
            redirectPath: `/save-to-list/players/${playerId}`,
            redirectSearch: `?next=/profiles/${playerId}`,
        });
    };

    const handleMessageIconClick = () => {
        if (isProProfile && !isPaidHitter) {
            props.setIsProMessagePopupFlg(true);
            return;
        }
        if (!isProfileClaimed) {
            props.setUnclaimedProfileMessagePopup(true);
            return;
        }
        props.handleShowLoginPopUp('message', true);
    };

    const renderIcons = () => (
        <>
            {!isOwnProfile && (
                <div
                    className={`${styles.icon}`}
                    onClick={handleMessageIconClick}
                    data-testid={tid('message-btn')}
                >
                    <Icon src="/img/v3/icons/icon-24px-message.svg" size={24} />
                </div>
            )}
            <ShareUrlPopUp
                title="Share Profile"
                className={`text-uppercase`}
                linkCopied={handleOnLinkCopied}
                data-testid={tid('share-popup')}
            >
                <div className={`${styles.icon}`} data-testid={tid('share-btn')}>
                    <Icon src="/img/v3/icons/icon-24px-share.svg" size={24} />
                </div>
            </ShareUrlPopUp>
            {savedListEnabled ? (
                // The bookmark glyph is narrower than the 24px message/share icons, so this wrapper
                // nudges it right to optically align in the desktop icon column (reset on mobile).
                <div className={styles.bookmarkIcon}>
                    {/* testid is the literal `profile.player-bookmark` per the ticket contract
                        (the verifier's selectors depend on it), not the drilled `profile.header.*` prefix. */}
                    <PlayerBookmark
                        playerId={playerId}
                        playerName={displayName}
                        isSaved={isPlayerSaved}
                        isLoading={isSavedStatusLoading}
                        savedListIds={savedPlayerListIds}
                        onSaveSuccess={onSaveToListSuccess}
                        onRemoveSuccess={onSaveToListSuccess}
                        variant="header"
                        data-testid="profile.player-bookmark"
                    />
                </div>
            ) : (
                isPowered && (
                    <div className={`${styles.icon}`} onClick={handleSaveToList} data-testid={tid('save-to-list-btn')}>
                        <Icon src={`/img/v3/icons/icon-24px-${isPlayerSavedToList ? 'following.svg' : 'follow.svg'}`} size={24} />
                    </div>
                )
            )}
        </>
    );

    const renderButtons = () => (
        <div className={styles.btnWrapper}>
            {isOwnProfile && (
                <TrackedClick
                    eventName="Profile Edit Info Clicked"
                    label="Edit profile"
                    traits={{}}
                >
                    <button
                        type="button"
                        onClick={() => {
                            props.history.push(`/profiles/${playerId}/edit`);
                        }}
                        className={`btn btn-white btn-inv btn-sm text-uppercase`}
                        data-testid={tid('edit-profile-btn')}
                        {...getClickAttrs({
                            category: `Player Profile`,
                            context: `Edit profile`,
                            location: 'Player Profile CTA',
                        })}
                    >
                        Edit profile
                    </button>
                </TrackedClick>
            )}
            {isEligibleForPaidHit && (
                <>
                    {!isOwnProfile && (
                        <button
                            type="button"
                            className={`${styles.paidHitButton} btn btn-white btn-inv btn-sm text-uppercase`}
                            onClick={handleOnRequestPaidHitClicked}
                            disabled={isSendingPaidHitRequest}
                            data-testid={tid('request-paid-hit-btn')}
                        >
                            {isSendingPaidHitRequest ? 'Sending...' : 'Request Paid Hit'}
                        </button>
                    )}
                    <button
                        type="button"
                        className={`${styles.paidHitButton} btn btn-white btn-inv btn-sm text-uppercase`}
                        onClick={handleOnViewPaidHitsClicked}
                        data-testid={tid('view-paid-hits-btn')}
                    >
                        View Paid Hits
                    </button>
                </>
            )}
        </div>
    );

    return (
        <div className={`${styles.profileHeader}`} data-testid={dataTestId}>
            <div className={`${styles.header}`} data-testid={tid('banner')}>
                <div className={`container`}>
                    <div className={`${styles.playerDetails}`} data-testid={tid('player-details')}>
                        <div className={`${styles.detailsWrapper}`}>
                            <div className={`${styles.flexColumn} ${styles.avatarAndDetails}`}>
                                <AvatarV3
                                    firstName={firstName}
                                    lastName={lastName}
                                    playerProfileImages={playerProfileImages}
                                    isOwnProfile={isOwnProfile}
                                    profileImage={profileImage}
                                    showCollegeProspectBadge={showCollegeProspectBadge}
                                    handleUploadPhoto={handleUploadPhoto}
                                    handleUploadPhotoPhotoStart={handleUploadPhotoPhotoStart}
                                    handleRemoveProfilePhoto={handleRemoveProfilePhoto}
                                    data-testid={tid('avatar')}
                                />
                                <div className={`${styles.detailsContainer}`}>
                                    <h1 className={`${styles.playerName}`} data-testid={tid('player-name')}>
                                        <span>{displayName}</span>
                                    </h1>
                                    <div className={`${styles.playerLocation}`} data-testid={tid('player-location')}>
                                        {showCollegeLink ? (
                                            <Link className={styles.playerLocationLink} to={`/colleges/${descriptionId}?t=1`} data-testid={tid('college-link')}>
                                                {descriptionLong}
                                            </Link>
                                        ) : (
                                            <>
                                                {locationText}
                                                {showLocationDivider && (
                                                    <span>&nbsp;<span className={`${styles.middleDot}`}>&nbsp;</span>&nbsp;</span>
                                                )}
                                                {homeClub || ''}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.flexColumn} ${styles.ratingsContainer}`}>
                                <RatingDisplayV5
                                    profileData={props.profileData}
                                    handleSignInClick={() => {
                                        props.handleShowLoginPopUp('ratingDisplay');
                                    }}
                                    isProProfile={isProProfile}
                                    auth={props.auth}
                                    isOwnProfile={isOwnProfile}
                                    onTennisGetRatedClick={onTennisGetRatedClick}
                                    onPickleballGetRatedClick={onPickleballGetRatedClick}
                                    data-testid={tid('rating')}
                                />
                            </div>
                            <div className="d-flex d-md-none mt20 mr-auto">
                                <CollegeProspectBadgeToggle
                                    profileData={props.profileData}
                                    isOwnProfile={isOwnProfile}
                                    isOn={showCollegeProspectBadge}
                                    onBadgeChange={setBadgeOverride}
                                    inputId="college-prospect-badge-toggle-mobile"
                                    data-testid={tid('college-prospect-badge-toggle-mobile')}
                                />
                            </div>
                            <div className={`${styles.hr} d-block d-md-none`} />
                            <div className={`${styles.iconsContainer}`}>
                                {renderIcons()}
                            </div>
                        </div>
                        <div className={`${styles.actionsContainer}`}>
                            <CollegeCoachAddProspect
                                profileData={props.profileData}
                                playerId={playerId}
                                isOwnProfile={isOwnProfile}
                                data-testid={tid('college-coach-add-prospect')}
                            />
                            <div className={`${styles.buttons}`}>
                                <div className="d-block d-md-none">
                                    {renderButtons()}
                                </div>
                                <div className="d-none d-md-block">
                                    {renderButtons()}
                                </div>
                                <div className="d-none d-md-block">
                                    <CollegeProspectBadgeToggle
                                        profileData={props.profileData}
                                        isOwnProfile={isOwnProfile}
                                        isOn={showCollegeProspectBadge}
                                        onBadgeChange={setBadgeOverride}
                                        data-testid={tid('college-prospect-badge-toggle')}
                                    />
                                </div>
                            </div>
                            {userLoggedIn && !isProProfile && !isCppEligibleCoach && (
                                <div className={`${styles.links}`}>
                                    <div onClick={handleProfileMerge} data-testid={tid('profile-merge-link')}>Request profile merge</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {props.showIsProMessagePopup && (
                    <JoinMeOnTourPopUp
                        message="If you want to play, come join me on the tour!"
                        closePopup={() => props.setIsProMessagePopupFlg(false)}
                    />
                )}
                {props.showUnclaimedProfileMessagePopup && (
                    <UnClaimedProfileMessagePopup
                        firstname={firstName}
                        gender={gender}
                        onCloseClick={() => props.setUnclaimedProfileMessagePopup(false)}
                    />
                )}
            </div>
        </div>
    );
};

ProfileHeader.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.shape({
            isPowered: PropTypes.bool,
            claimedPlayer: PropTypes.shape({
                id: PropTypes.number,
            }),
        }),
    }).isRequired,
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isEligibleForPaidHit: PropTypes.bool.isRequired,
    isSendingPaidHitRequest: PropTypes.bool.isRequired,
    onRequestPaidHitClicked: PropTypes.func.isRequired,
    onViewPaidHitsClicked: PropTypes.func.isRequired,
    isPlayerSavedToList: PropTypes.bool,
    isPlayerSaved: PropTypes.bool,
    isSavedStatusLoading: PropTypes.bool,
    savedPlayerListIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    onSaveToListSuccess: PropTypes.func,
    profileData: PropTypes.shape({
        id: PropTypes.number.isRequired,
        isPro: PropTypes.bool.isRequired,
        isPaidHitter: PropTypes.bool.isRequired,
        claimed: PropTypes.bool.isRequired,
        displayName: PropTypes.string.isRequired,
        profileImage: PropTypes.string,
        playerProfileImages: PropTypes.objectOf(any).isRequired,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        homeClub: PropTypes.string,
        location: PropTypes.shape({
            display: PropTypes.string,
        }).isRequired,
        descriptionId: PropTypes.number.isRequired,
        playerCollegeDetails: PropTypes.shape({
            gradYear: PropTypes.string,
            gradClassName: PropTypes.string,
        }),
        descriptionLong: PropTypes.string,
        gender: PropTypes.string.isRequired,
    }).isRequired,
    handleUploadPhoto: PropTypes.func.isRequired,
    handleUploadPhotoPhotoStart: PropTypes.func.isRequired,
    handleRemoveProfilePhoto: PropTypes.func.isRequired,
    menuSelected: PropTypes.func.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    setIsProMessagePopupFlg: PropTypes.func.isRequired,
    setUnclaimedProfileMessagePopup: PropTypes.func.isRequired,
    handleShowLoginPopUp: PropTypes.func.isRequired,
    showIsProMessagePopup: PropTypes.bool.isRequired,
    showUnclaimedProfileMessagePopup: PropTypes.bool.isRequired,
};

ProfileHeader.defaultProps = {
    isPlayerSavedToList: false,
    isPlayerSaved: false,
    isSavedStatusLoading: false,
    savedPlayerListIds: null,
    onSaveToListSuccess: null,
};

export default withRouter(withAuth(ProfileHeader));
